import { Inject, Injectable } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';

import { DataService } from '../http/dataService';
import { Repository } from './repository';

import { Service } from '../entity';
import { Dsa } from '../models/dsa.model';

@Service({
  model: Dsa,
  api: 'addressInfo/batch',
})
@Injectable({ providedIn: 'root' })
export class DsaService extends Repository<Dsa> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: env.api.backend.dsa.endpoint as string,
    });
  }

  createFromDTO(item): Dsa {
    //return item;
    return new Dsa(item);
  }
}
